import {createFeatureSelector, createSelector} from '@ngrx/store';
import {userReducer, UserState} from './user.reducer';

const userState = createFeatureSelector<UserState>(userReducer.name);

const getUserStatistics = () => createSelector(
  userState,
  (state) => state?.statistics
);

export const userSelectors = {
  getUserStatistics
}
